import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useRef, useState } from 'react';
import {
  crearPlaybackEngine,
  formatearInfoPlayback
} from '../utils/playbackEngine';

function HistoricalPlaybackV2({
  vehiculoSeleccionado,
  monitorUserId,
  setHistorialRuta,
  setPlaybackIndex,
  setPlaybackPosition,
  setPlaybackTravelledPath,
  setDetencionesHistoricas,
  onClose
}) {

  const [fechaInicio, setFechaInicio] = useState('');
  const [horaInicio, setHoraInicio] = useState('00:00');
  const [fechaFin, setFechaFin] = useState('');
  const [horaFin, setHoraFin] = useState('23:59');

  const [velocidad, setVelocidad] = useState('medio');
  const [cargando, setCargando] = useState(false);
  const [reproduciendo, setReproduciendo] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [totalPuntos, setTotalPuntos] = useState(0);
  const [puntoActual, setPuntoActual] = useState(0);
  const [indiceActual, setIndiceActual] = useState(0);
  const [rutaActual, setRutaActual] = useState([]);
  const [resumenRecorrido, setResumenRecorrido] = useState(null);
  const [mostrarResumen, setMostrarResumen] = useState(false);
  const [modoMovil, setModoMovil] = useState('configuracion');

 
  const [infoPlayback, setInfoPlayback] = useState({
    hora: '--:--:--',
    progreso: 0,
    velocidad: 0
  });

  const timerRef = useRef(null);
  const engineRef = useRef(null);
  const animationRef = useRef(null);
  const historyRequestRef = useRef(null);

  useEffect(() => () => {
    historyRequestRef.current?.abort();
  }, [monitorUserId, vehiculoSeleccionado?.maccezVehicleId, vehiculoSeleccionado?.id]);

  const obtenerDelay = () => {
    if (velocidad === 'lento') return 700;
    if (velocidad === 'rapido') return 120;
    return 300;
  };

  const obtenerFecha = (p) => {
    for (const key of Object.keys(p)) {
      if (key.toLowerCase().trim() === 'created_at') {
        return p[key];
      }
    }

    return null;
  };

  const obtenerDireccionGoogle = (lat, lng) => {
    return new Promise((resolve) => {
      if (!window.google?.maps) {
        resolve('Ubicación no disponible');
        return;
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode(
        { location: { lat: Number(lat), lng: Number(lng) } },
        (results, status) => {
          if (status === 'OK' && results?.[0]) {
            resolve(results[0].formatted_address);
          } else {
            resolve('Ubicación no disponible');
          }
        }
      );
    });
  };

  const formatearDuracion = (segundos) => {
    const total = Math.max(0, Math.round(segundos || 0));
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);

    if (horas > 0) return `${horas}h ${minutos} min`;
    return `${minutos} min`;
  };

const formatearHora = (fecha) => {
  if (!fecha) return '--:--';

  return fecha.toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

  const distanciaMetros = (a, b) => {
    const R = 6371000;
    const toRad = (v) => (v * Math.PI) / 180;

    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);

    const x =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(a.lat)) *
        Math.cos(toRad(b.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));

    return R * c;
  };

  const obtenerIgnicion = (p) => {
    if (p.ignition === 'ENCENDIDO' || Number(p.din1) === 1) {
      return 'ENCENDIDO';
    }

    if (p.ignition === 'APAGADO' || Number(p.din1) === 0) {
      return 'APAGADO';
    }

    return 'N/D';
  };

  const calcularResumenRecorrido = (ruta) => {
    if (!ruta || ruta.length < 2) return null;

    let tiempoEncendido = 0;
    let tiempoApagado = 0;
    let tiempoMovimiento = 0;
    let tiempoDetenido = 0;
    let distanciaTotal = 0;

    let velocidadMaxima = 0;
    let sumaVelocidadesEncendido = 0;
    let puntosVelocidadEncendido = 0;

    const rangos = {
      r0_20: 0,
      r21_40: 0,
      r41_60: 0,
      r61_80: 0,
      r80plus: 0
    };

    const periodosIgnicion = [];
    const detencionesCrudas = [];

    let estadoActual = obtenerIgnicion(ruta[0]);
    let inicioPeriodo = ruta[0].fecha;
    let puntoInicioPeriodo = ruta[0];

    let estadoDetencionActual = null;
    let inicioDetencion = null;
    let puntoInicioDetencion = null;

    const cerrarDetencion = (finFecha) => {
      if (!estadoDetencionActual || !inicioDetencion || !puntoInicioDetencion) {
        return;
      }

      const duracionSeg =
        (finFecha.getTime() - inicioDetencion.getTime()) / 1000;

      const duracionMinima =
  estadoDetencionActual === 'Detenido encendido'
    ? 300
    : 180;

if (duracionSeg >= duracionMinima) {
  detencionesCrudas.push({
    tipo: estadoDetencionActual,
    inicio: inicioDetencion,
    fin: finFecha,
    duracion: formatearDuracion(duracionSeg),
    lat: puntoInicioDetencion.lat,
    lng: puntoInicioDetencion.lng,
    direccion: 'Calculando ubicación...'
  });
}

      estadoDetencionActual = null;
      inicioDetencion = null;
      puntoInicioDetencion = null;
    };

    for (let i = 0; i < ruta.length - 1; i++) {
      const actual = ruta[i];
      const siguiente = ruta[i + 1];

      const t1 = actual.fecha?.getTime();
      const t2 = siguiente.fecha?.getTime();

      if (!t1 || !t2 || t2 <= t1) continue;

      const deltaSeg = (t2 - t1) / 1000;

      const distancia = distanciaMetros(actual, siguiente);
      distanciaTotal += distancia;

      const ignition = obtenerIgnicion(actual);
      const siguienteIgnition = obtenerIgnicion(siguiente);
      const speed = Number(actual.speed || 0);

      if (ignition === 'ENCENDIDO') {
        tiempoEncendido += deltaSeg;

        if (speed >= 5) {
          tiempoMovimiento += deltaSeg;
        } else {
          tiempoDetenido += deltaSeg;
        }

        velocidadMaxima = Math.max(velocidadMaxima, speed);
        sumaVelocidadesEncendido += speed;
        puntosVelocidadEncendido += 1;

        if (speed <= 20) rangos.r0_20 += deltaSeg;
        else if (speed <= 40) rangos.r21_40 += deltaSeg;
        else if (speed <= 60) rangos.r41_60 += deltaSeg;
        else if (speed <= 80) rangos.r61_80 += deltaSeg;
        else rangos.r80plus += deltaSeg;
      }

      if (ignition === 'APAGADO') {
        tiempoApagado += deltaSeg;
      }

      const tipoDetencion =
        ignition === 'APAGADO'
          ? 'Motor apagado'
          : ignition === 'ENCENDIDO' && speed < 5
          ? 'Detenido encendido'
          : null;

      if (tipoDetencion) {
        if (estadoDetencionActual !== tipoDetencion) {
          cerrarDetencion(actual.fecha);
          estadoDetencionActual = tipoDetencion;
          inicioDetencion = actual.fecha;
          puntoInicioDetencion = actual;
        }
      } else {
        cerrarDetencion(actual.fecha);
      }

      if (siguienteIgnition !== estadoActual) {
        periodosIgnicion.push({
          estado: estadoActual,
          inicio: inicioPeriodo,
          fin: siguiente.fecha,
          duracion: formatearDuracion(
            (siguiente.fecha.getTime() - inicioPeriodo.getTime()) / 1000
          )
        });

        estadoActual = siguienteIgnition;
        inicioPeriodo = siguiente.fecha;
        puntoInicioPeriodo = siguiente;
      }
    }

    cerrarDetencion(ruta[ruta.length - 1].fecha);

    periodosIgnicion.push({
      estado: estadoActual,
      inicio: inicioPeriodo,
      fin: ruta[ruta.length - 1].fecha,
      duracion: formatearDuracion(
        (ruta[ruta.length - 1].fecha.getTime() - inicioPeriodo.getTime()) / 1000
      )
    });

    const duracionTotal =
      (ruta[ruta.length - 1].fecha.getTime() - ruta[0].fecha.getTime()) / 1000;

    const velocidadPromedio =
      puntosVelocidadEncendido > 0
        ? Math.round(sumaVelocidadesEncendido / puntosVelocidadEncendido)
        : 0;

    const porcentajeRango = (valor) => {
      if (tiempoEncendido <= 0) return 0;
      return Math.round((valor / tiempoEncendido) * 100);
    };

    const inicioRuta = ruta[0];
    const finRuta = ruta[ruta.length - 1];

    const detencionesIntermedias = detencionesCrudas
      .filter((p) => {
        const distanciaInicio = distanciaMetros(p, inicioRuta);
        const distanciaFin = distanciaMetros(p, finRuta);

        return distanciaInicio > 40 && distanciaFin > 40;
      })
      .map((p, index) => ({
        ...p,
        numero: index + 1
      }));

    const periodosEncendido = periodosIgnicion.filter(
      (p) => p.estado === 'ENCENDIDO'
    ).length;

    const periodosApagado = periodosIgnicion.filter(
      (p) => p.estado === 'APAGADO'
    ).length;

    return {
      duracionTotal: formatearDuracion(duracionTotal),
      tiempoEncendido: formatearDuracion(tiempoEncendido),
      tiempoApagado: formatearDuracion(tiempoApagado),
      tiempoMovimiento: formatearDuracion(tiempoMovimiento),
      tiempoDetenido: formatearDuracion(tiempoDetenido),
      velocidadMaxima: Math.round(velocidadMaxima),
      velocidadPromedio,
      horaInicio: inicioRuta.fecha,
      horaFin: finRuta.fecha,
      lugarInicio: 'Calculando ubicación...',
      lugarFin: 'Calculando ubicación...',
      distanciaTotal:
        distanciaTotal >= 1000
          ? `${(distanciaTotal / 1000).toFixed(2)} km`
          : `${Math.round(distanciaTotal)} m`,
      periodosEncendido,
      periodosApagado,
      detencionesDetectadas: detencionesIntermedias,
      rangos: {
        '0-20 km/h': porcentajeRango(rangos.r0_20),
        '21-40 km/h': porcentajeRango(rangos.r21_40),
        '41-60 km/h': porcentajeRango(rangos.r41_60),
        '61-80 km/h': porcentajeRango(rangos.r61_80),
        '80+ km/h': porcentajeRango(rangos.r80plus)
      },
      tieneDatosOperativos: tiempoEncendido > 0 || tiempoApagado > 0
    };
  };

  const detener = (limpiar = false) => {
  if (engineRef.current) {
  engineRef.current.detener();
  engineRef.current = null;
}
    if (engineRef.current) {
  engineRef.current.detener();
  engineRef.current = null;
}
    if (animationRef.current) {
  cancelAnimationFrame(animationRef.current);
  animationRef.current = null;
}

    setReproduciendo(false);

    if (limpiar) {
      setMostrarResumen(false);
      setModoMovil('configuracion');
      setPuntoActual(0);
      setTotalPuntos(0);
      setHistorialRuta([]);
      setPlaybackIndex(0);
      setPlaybackPosition?.(null);
      setPlaybackTravelledPath?.([]);
      setMensaje('');
      setInfoPlayback({
        hora: '--:--:--',
        progreso: 0,
        velocidad: 0
      });
    }
  };
const iniciarMotorPlayback = (ruta, inicioIndex = 0) => {
  if (!ruta || ruta.length < 2) return;

  if (timerRef.current) {
    clearInterval(timerRef.current);
    timerRef.current = null;
  }

  if (engineRef.current) {
    engineRef.current.detener();
    engineRef.current = null;
  }

  setReproduciendo(true);
  setMensaje('Recorrido en reproducción');

  engineRef.current = crearPlaybackEngine({
    ruta,
    velocidad,
    desdeIndex: inicioIndex,
   onFrame: (estado) => {
  setPlaybackPosition?.(estado.position);
setPlaybackTravelledPath?.(
  estado.travelledPath && estado.travelledPath.length > 1
    ? estado.travelledPath
    : [
        ...ruta.slice(0, estado.index + 1),
        estado.position
      ]
);
  setIndiceActual(estado.index);
  setPlaybackIndex(estado.index);
  setPuntoActual(estado.index + 1);

  setInfoPlayback({
    hora: estado.position?.fecha
      ? new Date(estado.position.fecha).toLocaleTimeString('es-CO')
      : '--:--:--',
    progreso: estado.progress,
    velocidad: Math.round(Number(estado.position?.speed || 0))
  });
},
    onFinish: () => {
      engineRef.current = null;
      setReproduciendo(false);
      setMensaje('Recorrido finalizado');
    }
  });
};
  const iniciar = async () => {
    if (!vehiculoSeleccionado?.maccezVehicleId && !vehiculoSeleccionado?.id) {
      setMensaje('Selecciona un vehículo primero');
      return;
    }

    if (!fechaInicio || !fechaFin) {
      setMensaje('Selecciona fecha inicial y fecha final');
      return;
    }

    detener(true);
    historyRequestRef.current?.abort();
    const request = new AbortController();
    historyRequestRef.current = request;

    try {
      setCargando(true);
      setMensaje('Cargando histórico...');
      setHistorialRuta([]);
      setPlaybackIndex(0);
      setPuntoActual(0);
      setTotalPuntos(0);
      setDetencionesHistoricas?.([]);

    const params = new URLSearchParams({
        monitorUserId: String(monitorUserId),
        startDate: `${fechaInicio} ${horaInicio}:00`,
        endDate: `${fechaFin} ${horaFin}:00`
      });

      const vehicleId =
        vehiculoSeleccionado.maccezVehicleId || vehiculoSeleccionado.id;

      const res = await fetch(
        `/api/history/by-id/${encodeURIComponent(vehicleId)}?${params.toString()}`,
        {
          signal: request.signal,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (!res.ok) throw new Error('Histórico no autorizado o ambiguo');
      const data = await res.json();
      if (request.signal.aborted) return;

      const inicio = new Date(`${fechaInicio}T${horaInicio}`);
      const fin = new Date(`${fechaFin}T${horaFin}`);

      const rutaCompleta = data
        .map((p) => {
          const fechaOriginal = obtenerFecha(p);
          const fechaParsed = fechaOriginal
            ? new Date(fechaOriginal.replace(' ', 'T'))
            : null;

          return {
            lat: Number(p.latitude ?? p.lat),
            lng: Number(p.longitude ?? p.lng),
            fecha: fechaParsed,
            fechaOriginal,
            speed: Number(p.speed ?? 0),
            course: Number(p.course ?? 0),
            ignition: p.ignition ?? null,
            din1: p.din1 ?? null,
            address: p.address ?? null
          };
        })
        .filter(
          (p) =>
            !Number.isNaN(p.lat) &&
            !Number.isNaN(p.lng) &&
            p.lat !== 0 &&
            p.lng !== 0 &&
            p.fecha &&
            !Number.isNaN(p.fecha.getTime()) &&
            p.fecha >= inicio &&
            p.fecha <= fin
        );

      if (rutaCompleta.length < 2) {
        setMensaje('No hay recorrido disponible en ese rango');
        setCargando(false);
        return;
      }

      const resumenBase = calcularResumenRecorrido(rutaCompleta);

setResumenRecorrido(resumenBase);

const direccionInicio = await obtenerDireccionGoogle(
  rutaCompleta[0].lat,
  rutaCompleta[0].lng
);

const direccionFin = await obtenerDireccionGoogle(
  rutaCompleta[rutaCompleta.length - 1].lat,
  rutaCompleta[rutaCompleta.length - 1].lng
);

const detencionesConDireccion = await Promise.all(
  (resumenBase.detencionesDetectadas || []).map(async (detencion) => {
    const direccion = await obtenerDireccionGoogle(
      detencion.lat,
      detencion.lng
    );

    return {
      ...detencion,
      direccion
    };
  })
);

if (request.signal.aborted) return;
setDetencionesHistoricas?.(detencionesConDireccion);

setResumenRecorrido({
  ...resumenBase,
  lugarInicio: direccionInicio,
  lugarFin: direccionFin,
  detencionesDetectadas: detencionesConDireccion
});
      const esMovilActual =
  isMobileLayout();

setTotalPuntos(
  rutaCompleta.length
);

setHistorialRuta(
  rutaCompleta
);

setRutaActual(
  rutaCompleta
);

setIndiceActual(0);
setPlaybackIndex(0);
setPuntoActual(1);

setPlaybackPosition?.(
  rutaCompleta[0]
);

setPlaybackTravelledPath?.([
  rutaCompleta[0]
]);

setInfoPlayback(
  formatearInfoPlayback(
    rutaCompleta,
    0
  )
);

if (esMovilActual) {
  /*
    En aplicación solamente cargamos
    y presentamos el recorrido completo.
  */
  setReproduciendo(false);
  setMensaje('Recorrido listo');
  setModoMovil('playback');
} else {
  /*
    Escritorio conserva el inicio automático.
  */
  iniciarMotorPlayback(
    rutaCompleta,
    0
  );
}
    } catch (error) {
      if (request.signal.aborted) return;
      console.error('ERROR HISTORICO V2:', error);
      setMensaje('Error cargando histórico');
    } finally {
      if (!request.signal.aborted) setCargando(false);
    }
  };

const moverTimeline = (nuevoIndex) => {
  const index = Number(nuevoIndex);

  if (!rutaActual[index]) return;

  if (engineRef.current) {
    engineRef.current.detener();
    engineRef.current = null;
  }

  setReproduciendo(false);
  setMensaje('Recorrido pausado');

  setIndiceActual(index);
  setPlaybackIndex(index);
  setPuntoActual(index + 1);

  setPlaybackPosition?.(rutaActual[index]);

  setPlaybackTravelledPath?.(
    rutaActual.slice(0, index + 1)
  );

  setInfoPlayback({
    hora: rutaActual[index]?.fecha
      ? new Date(rutaActual[index].fecha).toLocaleTimeString('es-CO')
      : '--:--:--',
    progreso: Math.min(
      100,
      Math.round(((index + 1) / rutaActual.length) * 100)
    ),
    velocidad: Math.round(Number(rutaActual[index]?.speed || 0))
  });
};

const reproducirDesdeIndice = (inicioIndex = 0) => {
  if (!rutaActual || rutaActual.length < 2) return;

  if (timerRef.current) {
    clearInterval(timerRef.current);
    timerRef.current = null;
  }

  if (engineRef.current) {
    engineRef.current.detener();
    engineRef.current = null;
  }

  setReproduciendo(true);
  setMensaje('Recorrido en reproducción');

  engineRef.current = crearPlaybackEngine({
    ruta: rutaActual,
    velocidad,
    desdeIndex: inicioIndex,

    onFrame: (estado) => {
      setPlaybackPosition?.(estado.position);

      setPlaybackTravelledPath?.(
        estado.travelledPath && estado.travelledPath.length > 1
          ? estado.travelledPath
          : [
              ...rutaActual.slice(0, estado.index + 1),
              estado.position
            ]
      );

      setIndiceActual(estado.index);
      setPlaybackIndex(estado.index);
      setPuntoActual(estado.index + 1);

      setInfoPlayback({
        hora: estado.position?.fecha
          ? new Date(estado.position.fecha).toLocaleTimeString('es-CO')
          : '--:--:--',
        progreso: estado.progress,
        velocidad: Math.round(Number(estado.position?.speed || 0))
      });
    },

    onFinish: () => {
      engineRef.current = null;
      setReproduciendo(false);
      setMensaje('Recorrido finalizado');
    }
  });
};

  const pausarContinuar = () => {
if (reproduciendo) {
  if (engineRef.current) {
    engineRef.current.detener();
    engineRef.current = null;
  }

  setReproduciendo(false);
  setMensaje('Recorrido pausado');
  return;
}
    reproducirDesdeIndice(indiceActual);
  };

  useEffect(() => {
    if (!reproduciendo) return;
    if (!rutaActual || rutaActual.length < 2) return;

    reproducirDesdeIndice(indiceActual);
  }, [velocidad]);
const aplicarRangoRapido = (horas) => {
  const fin = new Date();
  const inicio = new Date(fin.getTime() - horas * 60 * 60 * 1000);

const formatearFechaInput = (fecha) => {
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');

    return `${anio}-${mes}-${dia}`;
  };

  const formatearHoraInput = (fecha) => {
    return fecha.toTimeString().slice(0, 5);
  };

  setFechaInicio(formatearFechaInput(inicio));
  setHoraInicio(formatearHoraInput(inicio));
  setFechaFin(formatearFechaInput(fin));
  setHoraFin(formatearHoraInput(fin));
};

const esMovil = isMobileLayout();

const tocar = (e, accion) => {
  e.preventDefault();
  e.stopPropagation();
  accion();
};


const cambiarVelocidadCiclica = () => {
  setVelocidad((actual) => {
    if (actual === 'lento') return 'medio';
    if (actual === 'medio') return 'rapido';
    return 'lento';
  });
};
const cerrarHistorico = () => {
  detener(true);
  setResumenRecorrido(null);
  setMostrarResumen(false);
  setRutaActual([]);
  setDetencionesHistoricas?.([]);

  if (typeof onClose === 'function') {
    onClose();
  }
};

const limpiarSeleccionHistorica = () => {
  detener(true);

  setFechaInicio('');
  setHoraInicio('00:00');

  setFechaFin('');
  setHoraFin('23:59');

  setRutaActual([]);
  setIndiceActual(0);

  setResumenRecorrido(null);
  setMostrarResumen(false);

  setDetencionesHistoricas?.([]);

  setCargando(false);
  setMensaje('');
};
const accionPrincipalPlayback = () => {
  if (
    totalPuntos === 0 ||
    rutaActual.length < 2
  ) {
    return;
  }

  if (reproduciendo) {
    if (engineRef.current) {
      engineRef.current.detener();
      engineRef.current = null;
    }

    setReproduciendo(false);
    setMensaje('Recorrido pausado');
    return;
  }

  let indiceInicio =
    indiceActual;

  if (
    mensaje === 'Recorrido finalizado' ||
    indiceActual >= rutaActual.length - 1
  ) {
    indiceInicio = 0;

    setIndiceActual(0);
    setPlaybackIndex(0);
    setPuntoActual(1);

    setPlaybackPosition?.(
      rutaActual[0]
    );

    setPlaybackTravelledPath?.([
      rutaActual[0]
    ]);

    setInfoPlayback(
      formatearInfoPlayback(
        rutaActual,
        0
      )
    );
  }

  window.dispatchEvent(
    new CustomEvent(
      'maccez:history-playback-start'
    )
  );

  reproducirDesdeIndice(
    indiceInicio
  );
};
return (
  <div style={{ display: 'contents' }}>
   

    <div
style={
  esMovil &&
  modoMovil === 'playback'
    ? panelPlaybackMovilStyle
    : panelStyle
}
    >
{esMovil && modoMovil === 'playback' ? (
  <>
    <div style={mobileHistoryHeaderStyle}>
      <div
        style={{
          minWidth: 0,
          flex: 1
        }}
      >
        <div style={mobileHistoryEyebrowStyle}>
          RECORRIDO HISTÓRICO
        </div>

        <h3
          style={{
            ...mobileHistoryTitleStyle,
            fontSize: 21
          }}
        >
          Histórico
        </h3>

        <div style={mobileHistoryVehicleStyle}>
          {vehiculoSeleccionado?.name ||
            'Activo seleccionado'}
        </div>
      </div>

      <button
        type="button"
        onPointerUp={(e) =>
          tocar(
            e,
            cerrarHistorico
          )
        }
        style={mobileHistoryCloseStyle}
        aria-label="Cerrar histórico"
      >
        ×
      </button>
    </div>

    <div style={playbackMainRowStyle}>
      <div
        style={{
          ...playbackInfoStyle,
          flex: 1,
          minWidth: 0,
          marginTop: 0
        }}
      >
        <span>
          Hora: {infoPlayback.hora}
        </span>

        <strong>
          {infoPlayback.velocidad} km/h
        </strong>
      </div>

      <button
        type="button"
        onPointerUp={(e) =>
          tocar(
            e,
            accionPrincipalPlayback
          )
        }
        disabled={totalPuntos === 0}
        style={{
          ...playPauseMobileButtonStyle,

          opacity:
            totalPuntos === 0
              ? 0.5
              : 1,

          cursor:
            totalPuntos === 0
              ? 'not-allowed'
              : 'pointer'
        }}
        aria-label={
          reproduciendo
            ? 'Pausar recorrido'
            : 'Reproducir recorrido'
        }
      >
        {reproduciendo
          ? 'Ⅱ'
          : '▶'}
      </button>
    </div>

    <div style={timelineCompactRowStyle}>
      <div
        style={{
          flex: 1,
          minWidth: 0
        }}
      >
        <input
          type="range"
          min="0"
          max={Math.max(
            totalPuntos - 1,
            0
          )}
          value={indiceActual}
          disabled={totalPuntos === 0}
          onChange={(e) =>
            moverTimeline(
              e.target.value
            )
          }
          style={rangeStyle}
        />

        <p style={progresoStyle}>
          Progreso: {infoPlayback.progreso}%
        </p>
      </div>

      <button
        type="button"
        onPointerUp={(e) =>
          tocar(
            e,
            cambiarVelocidadCiclica
          )
        }
        style={speedSingleButtonStyle}
      >
        {velocidad === 'rapido'
          ? 'Rápido'
          : velocidad === 'lento'
          ? 'Lento'
          : 'Medio'}
      </button>
    </div>

    <button
      type="button"
      disabled={!resumenRecorrido}
      onPointerUp={(e) =>
        tocar(e, () => {
          if (!resumenRecorrido) {
            return;
          }

          setMostrarResumen(
            (actual) => !actual
          );
        })
      }
      style={{
        ...mobileSummaryButtonStyle,

        opacity:
          resumenRecorrido
            ? 1
            : 0.5,

        cursor:
          resumenRecorrido
            ? 'pointer'
            : 'not-allowed'
      }}
    >
      <span style={mobileSummaryIconStyle}>
        ≡
      </span>

      <span>
        {mostrarResumen
          ? 'Ocultar resumen operativo'
          : 'Ver resumen operativo'}
      </span>

      <span style={mobileSummaryArrowStyle}>
        {mostrarResumen
          ? '↓'
          : '↑'}
      </span>
    </button>
  </>
      ) : esMovil ? (
        <>
      <div style={mobileHistoryHeaderStyle}>
  <div style={{ minWidth: 0 }}>
    <div style={mobileHistoryEyebrowStyle}>
      RECORRIDO
    </div>

    <h3 style={mobileHistoryTitleStyle}>
      Histórico
    </h3>

    <div style={mobileHistoryVehicleStyle}>
      {vehiculoSeleccionado?.name || 'Activo seleccionado'}
    </div>
  </div>

  <button
    type="button"
    onClick={cerrarHistorico}
    style={mobileHistoryCloseStyle}
    aria-label="Cerrar histórico"
  >
    ×
  </button>
</div>

          <div style={quickRangeHeaderStyle}>Accesos rápidos</div>

          <div style={quickRangeGroupStyle}>
            <button type="button" onClick={() => aplicarRangoRapido(1)} style={quickRangeButtonStyle}>
              1 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(6)} style={quickRangeButtonStyle}>
              6 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(12)} style={quickRangeButtonStyle}>
              12 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(24)} style={quickRangeButtonStyle}>
              24 h
            </button>
          </div>

          <div style={mobileDateCompactGridStyle}>
  <div style={mobileDateItemStyle}>
    <span style={mobileDateLabelStyle}>Desde</span>
    <input
      type="date"
      value={fechaInicio}
      onChange={(e) => setFechaInicio(e.target.value)}
      style={mobileDateInputStyle}
    />
  </div>

  <div style={mobileDateItemStyle}>
    <span style={mobileDateLabelStyle}>Hora</span>
    <input
      type="time"
      value={horaInicio}
      onChange={(e) => setHoraInicio(e.target.value)}
      style={mobileTimeInputStyle}
    />
  </div>

  <div style={mobileDateItemStyle}>
    <span style={mobileDateLabelStyle}>Hasta</span>
    <input
      type="date"
      value={fechaFin}
      onChange={(e) => setFechaFin(e.target.value)}
      style={mobileDateInputStyle}
    />
  </div>

  <div style={mobileDateItemStyle}>
    <span style={mobileDateLabelStyle}>Hora</span>
    <input
      type="time"
      value={horaFin}
      onChange={(e) => setHoraFin(e.target.value)}
      style={mobileTimeInputStyle}
    />
  </div>
</div>

          <div style={controlGroupStyle}>
            <button
              onClick={iniciar}
              disabled={cargando || reproduciendo}
              style={{
                ...controlButtonStyle,
                ...controlStartStyle,
                opacity: cargando || reproduciendo ? 0.55 : 1,
                cursor: cargando || reproduciendo ? 'not-allowed' : 'pointer'
              }}
            >
              ▶️ {cargando ? 'Cargando' : 'Iniciar'}
            </button>

            <button
            onClick={limpiarSeleccionHistorica}
              style={{
                ...controlButtonStyle,
                ...controlStopStyle
              }}
            >
              ■ Limpiar
            </button>
          </div>

          <p style={mensajeStyle}>{mensaje}</p>
        </>
      ) : (
        <>
          <div style={headerStyle}>
       <div style={{ minWidth: 0 }}>
  <h3 style={tituloStyle}>Histórico</h3>

  {vehiculoSeleccionado?.name && (
    <p style={activoHistoricoStyle}>
      {vehiculoSeleccionado.name}
    </p>
  )}

  <p style={subtituloStyle}>Playback inteligente</p>
</div>
<button
              type="button"
              onClick={cerrarHistorico}
              style={closeButtonStyle}
              aria-label="Cerrar histórico"
            >
              ×
            </button>
          </div>

          <div style={quickRangeHeaderStyle}>Accesos rápidos</div>

          <div style={quickRangeGroupStyle}>
            <button type="button" onClick={() => aplicarRangoRapido(1)} style={quickRangeButtonStyle}>
              1 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(6)} style={quickRangeButtonStyle}>
              6 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(12)} style={quickRangeButtonStyle}>
              12 h
            </button>

            <button type="button" onClick={() => aplicarRangoRapido(24)} style={quickRangeButtonStyle}>
              24 h
            </button>
          </div>

          <label style={labelStyle}>Desde</label>

          <div style={dateTimeRowStyle}>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              style={inputDateStyle}
            />

            <input
              type="time"
              value={horaInicio}
              onChange={(e) => setHoraInicio(e.target.value)}
              style={inputTimeStyle}
            />
          </div>

          <label style={labelStyle}>Hasta</label>

          <div style={dateTimeRowStyle}>
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              style={inputDateStyle}
            />

            <input
              type="time"
              value={horaFin}
              onChange={(e) => setHoraFin(e.target.value)}
              style={inputTimeStyle}
            />
          </div>

          <div style={controlGroupStyle}>
            <button
              onClick={iniciar}
              disabled={cargando || reproduciendo}
              style={{
                ...controlButtonStyle,
                ...controlStartStyle,
                opacity: cargando || reproduciendo ? 0.55 : 1,
                cursor: cargando || reproduciendo ? 'not-allowed' : 'pointer'
              }}
            >
              ▶️ {cargando ? 'Cargando' : 'Iniciar'}
            </button>

            <button
              onClick={pausarContinuar}
              disabled={totalPuntos === 0}
              style={{
                ...controlButtonStyle,
                ...controlPauseStyle,
                opacity: totalPuntos === 0 ? 0.55 : 1,
                cursor: totalPuntos === 0 ? 'not-allowed' : 'pointer'
              }}
            >
              {reproduciendo ? 'Ⅱ Pausa' : '▶️ Seguir'}
            </button>

            <button
              onClick={() => detener(true)}
              style={{
                ...controlButtonStyle,
                ...controlStopStyle
              }}
            >
              ■ Detener
            </button>
          </div>

          <div style={playbackSpeedHeaderStyle}>
            <span>Velocidad de reproducción</span>
            <strong>
              {velocidad === 'rapido'
                ? 'Rápido'
                : velocidad === 'lento'
                ? 'Lento'
                : 'Medio'}
            </strong>
          </div>

          <div style={speedGroupStyle}>
            <button
              type="button"
              onClick={() => setVelocidad('lento')}
              style={velocidad === 'lento' ? speedButtonActiveStyle : speedButtonStyle}
            >
              Lento
            </button>

            <button
              type="button"
              onClick={() => setVelocidad('medio')}
              style={velocidad === 'medio' ? speedButtonActiveStyle : speedButtonStyle}
            >
              Medio
            </button>

            <button
              type="button"
              onClick={() => setVelocidad('rapido')}
              style={velocidad === 'rapido' ? speedButtonActiveStyle : speedButtonStyle}
            >
              Rápido
            </button>
          </div>

          <p style={mensajeStyle}>{mensaje}</p>

          <div style={playbackInfoStyle}>
            <span>Hora: {infoPlayback.hora}</span>
            <strong>{infoPlayback.velocidad} km/h</strong>
          </div>

          <input
            type="range"
            min="0"
            max={Math.max(totalPuntos - 1, 0)}
            value={indiceActual}
            disabled={totalPuntos === 0}
            onChange={(e) => moverTimeline(e.target.value)}
            style={rangeStyle}
          />

          <p style={progresoStyle}>Progreso: {infoPlayback.progreso}%</p>

          {resumenRecorrido && (
            <button
              type="button"
              onClick={() => setMostrarResumen(!mostrarResumen)}
              style={verResumenButtonStyle}
            >
              {mostrarResumen ? 'Ocultar resumen' : 'Ver resumen operativo'}
            </button>
          )}
        </>
      )}
    </div>

  {resumenRecorrido && mostrarResumen && (
  <div
    style={
      esMovil
        ? mobileSummarySheetStyle
        : resumenBottomPanelStyle
    }
  >
    {esMovil ? (
      <div style={mobileSummaryHeaderStyle}>
        <div style={{ minWidth: 0 }}>
          <div style={mobileSummaryEyebrowStyle}>
            REPORTE DEL RECORRIDO
          </div>

          <strong style={mobileSummaryTitleStyle}>
            Resumen operativo
          </strong>

          <span style={mobileSummaryVehicleStyle}>
            {vehiculoSeleccionado?.name ||
              'Activo seleccionado'}
          </span>
        </div>

        <button
          type="button"
          onPointerUp={(e) =>
            tocar(e, () => {
              setMostrarResumen(false);
            })
          }
          style={mobileSummaryCloseStyle}
          aria-label="Cerrar resumen"
        >
          ×
        </button>
      </div>
    ) : (
      <div style={resumenHeaderBottomStyle}>
        <strong>Resumen operativo</strong>

        <span>
          Datos consolidados del recorrido histórico
        </span>
      </div>
    )}

    <div
      style={
        esMovil
          ? mobileSummaryScrollStyle
          : undefined
      }
    >
      <div
        style={
          esMovil
            ? mobileSummaryGridStyle
            : resumenGridBottomStyle
        }
      >
        <div
          style={
            esMovil
              ? mobileSummarySectionStyle
              : resumenColumnStyle
          }
        >
          <div
            style={
              esMovil
                ? mobileSummarySectionTitleStyle
                : resumenTitleStyle
            }
          >
            Recorrido
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRouteItemStyle
                : recorridoItemStyle
            }
          >
            <strong style={{ color: '#16a34a' }}>
              Inicio
            </strong>

            <span>
              {resumenRecorrido.lugarInicio}
            </span>

            <em>
              {formatearHora(
                resumenRecorrido.horaInicio
              )}
            </em>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRouteItemStyle
                : recorridoItemStyle
            }
          >
            <strong style={{ color: '#dc2626' }}>
              Fin
            </strong>

            <span>
              {resumenRecorrido.lugarFin}
            </span>

            <em>
              {formatearHora(
                resumenRecorrido.horaFin
              )}
            </em>
          </div>
        </div>

        <div
          style={
            esMovil
              ? mobileSummarySectionStyle
              : resumenColumnStyle
          }
        >
          <div
            style={
              esMovil
                ? mobileSummarySectionTitleStyle
                : resumenTitleStyle
            }
          >
            Métricas
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Distancia</span>

            <strong>
              {resumenRecorrido.distanciaTotal}
            </strong>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Duración total</span>

            <strong>
              {resumenRecorrido.duracionTotal}
            </strong>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Motor encendido</span>

            <strong>
              {resumenRecorrido.tiempoEncendido}
            </strong>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Motor apagado</span>

            <strong>
              {resumenRecorrido.tiempoApagado}
            </strong>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Vel. máxima</span>

            <strong>
              {resumenRecorrido.velocidadMaxima} km/h
            </strong>
          </div>

          <div
            style={
              esMovil
                ? mobileSummaryRowStyle
                : resumenRowStyle
            }
          >
            <span>Vel. promedio</span>

            <strong>
              {resumenRecorrido.velocidadPromedio} km/h
            </strong>
          </div>
        </div>

        <div
          style={
            esMovil
              ? mobileSummarySectionStyle
              : resumenColumnStyle
          }
        >
          <div
            style={
              esMovil
                ? mobileSummarySectionTitleStyle
                : resumenTitleStyle
            }
          >
            Paradas
          </div>

          {(resumenRecorrido.detencionesDetectadas || [])
            .length === 0 && (
            <div
              style={
                esMovil
                  ? mobileSummaryEmptyStyle
                  : emptyResumenStyle
              }
            >
              Sin paradas relevantes
            </div>
          )}

          {(resumenRecorrido.detencionesDetectadas || [])
            .map((p) => (
              <div
                key={p.numero}
                style={
                  esMovil
                    ? mobileSummaryRouteItemStyle
                    : recorridoItemStyle
                }
              >
                <strong style={{ color: '#ea580c' }}>
                  P{p.numero} · {p.tipo}
                </strong>

                <span>
                  {p.direccion}
                </span>

                <em>
                  {formatearHora(p.inicio)}
                  {' - '}
                  {formatearHora(p.fin)}
                  {' · '}
                  {p.duracion}
                </em>
              </div>
            ))}
        </div>

        <div
          style={
            esMovil
              ? mobileSummarySectionStyle
              : resumenColumnStyle
          }
        >
          <div
            style={
              esMovil
                ? mobileSummarySectionTitleStyle
                : resumenTitleStyle
            }
          >
            Rangos de velocidad
          </div>

          {Object.entries(
            resumenRecorrido.rangos || {}
          ).map(([rango, porcentaje]) => (
            <div
              key={rango}
              style={
                esMovil
                  ? mobileSummaryRowStyle
                  : resumenRowStyle
              }
            >
              <span>{rango}</span>

              <strong>{porcentaje}%</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)}
  </div>
);
}

let panelStyle = {
  position: 'fixed',
  top: 128,
  right: 18,
  zIndex: 9999,
  width: 330,
  height: 'auto',
  maxHeight: 'calc(100vh - 150px)',
  overflow: 'hidden',
  color: '#f8fafc',
  padding: 9,
  borderRadius: 20,
  background:
    'linear-gradient(160deg, rgba(7, 24, 58, 0.98), rgba(11, 43, 91, 0.96), rgba(15, 73, 128, 0.92))',
  border: '1px solid rgba(96, 165, 250, 0.28)',
  boxShadow:
    '0 24px 60px rgba(2, 8, 23, 0.62), inset 0 1px 0 rgba(255,255,255,0.08)',
  backdropFilter: 'blur(16px)'
};
let panelPlaybackMovilStyle = {
  position: 'fixed',

  top: 'auto',
  left: 10,
  right: 10,

  bottom:
    'calc(env(safe-area-inset-bottom, 0px) + 40px)',

  zIndex: 9999,

  width: 'auto',
  height: 'auto',
  maxHeight: 240,

  padding: 12,
  boxSizing: 'border-box',

  overflow: 'hidden',

  borderRadius: 22,

  background:
    'linear-gradient(155deg, rgba(248,251,255,0.98), rgba(231,241,253,0.97))',

  border:
    '1px solid rgba(255,255,255,0.94)',

  boxShadow:
    '0 14px 36px rgba(15,23,42,0.14), inset 0 1px 0 rgba(255,255,255,0.95)',

  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',

  color: '#0f172a',

  transition:
    'height 220ms ease, max-height 220ms ease',

  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent'
};

let headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
  marginBottom: 8,
  paddingBottom: 7,
  borderBottom: '1px solid rgba(148, 163, 184, 0.16)'
};

let tituloStyle = {
  margin: 0,
  fontSize: 19,
  fontWeight: 900,
  letterSpacing: -0.4,
  color: '#ffffff'
};

let subtituloStyle = {
  margin: 0,
  marginTop: 1,
  fontSize: 10,
  color: '#bfdbfe',
  fontWeight: 600
};
const activoHistoricoStyle = {
  margin: '2px 0 0',
  fontSize: 12,
  fontWeight: 900,
  color: '#ffffff',
  maxWidth: 210,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
let estadoMiniStyle = {
  padding: '5px 8px',
  borderRadius: 999,
  background: 'rgba(14, 165, 233, 0.16)',
  border: '1px solid rgba(56, 189, 248, 0.35)',
  color: '#7dd3fc',
  fontSize: 10.5,
  fontWeight: 900,
  whiteSpace: 'nowrap'
};

let labelStyle = {
  display: 'block',
  fontSize: 17,
  fontWeight: 500,
  color: '#e0f2fe',
  marginTop: 3,
  marginBottom: 1
};

let inputStyle = {
  width: '100%',
  marginTop: 3,
  marginBottom: 5,
  padding: '7px 10px',
  borderRadius: 10,
  border: '1px solid rgba(147, 197, 253, 0.22)',
  background: 'rgba(2, 6, 23, 0.38)',
  color: '#ffffff',
  fontSize: 12,
  outline: 'none',
  colorScheme: 'dark'
};

const mensajeStyle = {
  fontSize: 10.5,
  marginTop: 5,
  marginBottom: 0,
  color: '#dbeafe',
  fontWeight: 600
};

let playbackInfoStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 11,
  color: '#bae6fd',
  fontWeight: 800,
  marginTop: 6,
  padding: '7px 9px',
  borderRadius: 11,
  background: 'rgba(2, 6, 23, 0.30)',
  border: '1px solid rgba(125, 211, 252, 0.18)'
};

let rangeStyle = {
  width: '100%',
  marginTop: 6
};

let progresoStyle = {
  fontSize: 10.5,
  marginTop: 3,
  marginBottom: 3,
  color: '#bfdbfe',
  fontWeight: 800
};

const resumenTitleStyle = {
  fontSize: 11,
  fontWeight: 900,
  color: '#7dd3fc',
  marginBottom: 9,
  textTransform: 'uppercase',
  letterSpacing: 0.7
};

const recorridoItemStyle = {
  display: 'grid',
  gap: 3,
  padding: 9,
  borderRadius: 13,
  background: 'rgba(15, 23, 42, 0.42)',
  border: '1px solid rgba(255,255,255,0.07)',
  fontSize: 11,
  lineHeight: 1.25
};

const resumenRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 10,
  fontSize: 12,
  padding: '6px 0',
  borderBottom: '1px solid rgba(191, 219, 254, 0.10)'
};

let speedGroupStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: 6,
  marginBottom: 5
};

let speedButtonStyle = {
  padding: '6px 6px',
  borderRadius: 9,
  border: '1px solid rgba(147, 197, 253, 0.20)',
  background: 'rgba(2, 6, 23, 0.28)',
  color: '#bfdbfe',
  fontSize: 10.5,
  fontWeight: 800,
  cursor: 'pointer'
};

const speedButtonActiveStyle = {
  ...speedButtonStyle,
  background:
    'linear-gradient(135deg, rgba(14,165,233,0.95), rgba(37,99,235,0.92))',
  color: '#ffffff',
  border: '1px solid rgba(125, 211, 252, 0.55)',
  boxShadow: '0 6px 16px rgba(14,165,233,0.22)'
};

let controlGroupStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: 6,
  marginTop: 5
};

let controlButtonStyle = {
  height: 31,
  borderRadius: 10,
  border: '1px solid rgba(255,255,255,0.10)',
  color: '#ffffff',
  fontSize: 10.5,
  fontWeight: 900,
  cursor: 'pointer',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12)'
};

const controlStartStyle = {
  background: 'linear-gradient(135deg, #0f766e, #0891b2)'
};

const controlPauseStyle = {
  background: 'linear-gradient(135deg, #1d4ed8, #0284c7)'
};

const controlStopStyle = {
  background: 'linear-gradient(135deg, #7f1d1d, #b91c1c)'
};

let playbackSpeedHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 6,
  marginBottom: 4,
  fontSize: 10.5,
  color: '#dbeafe',
  fontWeight: 800
};

let verResumenButtonStyle = {
  width: '100%',
  marginTop: 5,
  padding: '7px 10px',
  borderRadius: 11,
  border: '1px solid rgba(125, 211, 252, 0.25)',
  background: 'rgba(2, 6, 23, 0.30)',
  color: '#bae6fd',
  fontSize: 11,
  fontWeight: 900,
  cursor: 'pointer'
};
const closeButtonStyle = {
  width: 30,
  height: 30,
  padding: 0,
  borderRadius: 9,
  border: '1px solid rgba(255,255,255,0.16)',
  background: 'rgba(255,255,255,0.08)',
  color: '#ffffff',
  fontSize: 20,
  fontWeight: 900,
  lineHeight: 1,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const resumenBottomPanelStyle = {
  position: 'fixed',
  left: 90,
  right: 370,
  bottom: 18,
  zIndex: 30000,
  height: 260,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 14,
  borderRadius: 22,
  background:
    'linear-gradient(160deg, rgba(7, 24, 58, 0.98), rgba(11, 43, 91, 0.96), rgba(15, 73, 128, 0.92))',
  border: '1px solid rgba(96, 165, 250, 0.28)',
  boxShadow:
    '0 24px 60px rgba(2, 8, 23, 0.65), inset 0 1px 0 rgba(255,255,255,0.08)',
  backdropFilter: 'blur(16px)',
  color: '#f8fafc'
};

const resumenHeaderBottomStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  marginBottom: 10,
  paddingBottom: 8,
  borderBottom: '1px solid rgba(148, 163, 184, 0.16)',
  fontSize: 12,
  color: '#dbeafe'
};

const resumenGridBottomStyle = {
  display: 'grid',
  gridTemplateColumns: '1.2fr 1fr 1.4fr 0.9fr',
  gap: 12
};

const resumenColumnStyle = {
  display: 'grid',
  gap: 7,
  alignContent: 'start',
  minWidth: 0
};

const emptyResumenStyle = {
  padding: 10,
  borderRadius: 12,
  background: 'rgba(15, 23, 42, 0.35)',
  border: '1px solid rgba(255,255,255,0.07)',
  color: '#bfdbfe',
  fontSize: 11,
  fontWeight: 700
};

let quickRangeHeaderStyle = {
  marginTop: 5,
  marginBottom: 4,
  fontSize: 10.5,
  color: '#dbeafe',
  fontWeight: 800
};

let quickRangeGroupStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr',
  gap: 5,
  marginBottom: 6
};

let quickRangeButtonStyle = {
  padding: '6px 5px',
  borderRadius: 9,
  border: '1px solid rgba(147, 197, 253, 0.20)',
  background: 'rgba(2, 6, 23, 0.28)',
  color: '#bfdbfe',
  fontSize: 10.5,
  fontWeight: 900,
  cursor: 'pointer'
};
let dateTimeRowStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 0.75fr',
  gap: 6,
  marginBottom: 5
};

let inputDateStyle = {
  ...inputStyle,
  width: '100%',
  minWidth: 0,
  minHeight: 42,
  height: 42,
  padding: '0 40px 0 10px',
  marginTop: 0,
  marginBottom: 0,
  WebkitAppearance: 'none',
  appearance: 'none'
};
let inputTimeStyle = {
  ...inputStyle,
  width: '100%',
  minWidth: 128,
  minHeight: 42,
  height: 42,
  padding: '0 34px 0 10px',
  marginTop: 0,
  marginBottom: 0,
  textAlign: 'center',
  WebkitAppearance: 'none',
  appearance: 'none'
};
const miniButtonStyle = {
  width: 38,
  height: 38,
  borderRadius: 999,
  border: '1px solid rgba(125, 211, 252, 0.35)',
  background: 'rgba(14, 165, 233, 0.24)',
  color: '#bae6fd',
  fontSize: 18,
  fontWeight: 900,
  cursor: 'pointer',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent'
};
const timelineCompactRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginTop: 5
};

const speedSingleButtonStyle = {
  minWidth: 76,
  height: 36,
  borderRadius: 999,
  border: '1px solid rgba(125, 211, 252, 0.35)',
  background:
    'linear-gradient(135deg, rgba(14,165,233,0.95), rgba(37,99,235,0.92))',
  color: '#ffffff',
  fontSize: 12,
  fontWeight: 900,
  cursor: 'pointer',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent'
};

const mainPlaybackButtonStyle = {
  width: '100%',
  height: 38,
  marginTop: 6,
  borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.10)',
  color: '#ffffff',
  fontSize: 13,
  fontWeight: 900,
  cursor: 'pointer',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12)',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent'
};
const mobileDateCompactGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 0.8fr 1fr 0.8fr',
  gap: 6,
  marginTop: 6,
  marginBottom: 7
};

const mobileDateItemStyle = {
  minWidth: 0
};

const mobileDateLabelStyle = {
  display: 'block',
  fontSize: 9.5,
  fontWeight: 900,
  color: '#7dd3fc',
  marginBottom: 2
};

const mobileDateInputStyle = {
  width: '100%',
  height: 32,
  minWidth: 0,
  padding: '0 4px',
  borderRadius: 9,
  border: '1px solid rgba(147, 197, 253, 0.22)',
  background: 'rgba(2, 6, 23, 0.38)',
  color: '#ffffff',
  fontSize: 10.5,
  fontWeight: 800,
  outline: 'none',
  colorScheme: 'dark',
  WebkitAppearance: 'none',
  appearance: 'none'
};

const mobileTimeInputStyle = {
  ...mobileDateInputStyle,
  textAlign: 'center'
};
const mobileDragHeaderStyle = {
  ...headerStyle,
  cursor: 'pointer',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  marginBottom: 5,
  paddingBottom: 6
};

const dragIndicatorStyle = {
  fontSize: 10.5,
  fontWeight: 900,
  color: '#7dd3fc',
  padding: '5px 8px',
  borderRadius: 999,
  background: 'rgba(14, 165, 233, 0.14)',
  border: '1px solid rgba(125, 211, 252, 0.22)',
  whiteSpace: 'nowrap'
};
const isMobile = isMobileLayout();

if (isMobile) {
  dateTimeRowStyle = {
    ...dateTimeRowStyle,
    gridTemplateColumns: '1fr 0.82fr',
    gap: 6,
    marginBottom: 5
  };

inputDateStyle = {
  ...inputDateStyle,
  height: 42,
  minHeight: 42,
  fontSize: 13
};

inputTimeStyle = {
  ...inputTimeStyle,
  height: 42,
  minHeight: 42,
  fontSize: 13
};
panelStyle = {
  ...panelStyle,

  position: 'fixed',
  top: 'auto',

  left: 10,
  right: 10,

  bottom:
    'calc(env(safe-area-inset-bottom, 0px) + 40px)',

  width: 'auto',
  height: 'auto',

  maxHeight:
    'calc(100dvh - env(safe-area-inset-top, 0px) - 175px)',

  padding: 12,
  boxSizing: 'border-box',

  overflowX: 'hidden',
  overflowY: 'auto',

  borderRadius: 22,

 background:
  'linear-gradient(155deg, rgba(248,251,255,0.98), rgba(231,241,253,0.97))',

border:
  '1px solid rgba(255,255,255,0.94)',

boxShadow:
  '0 14px 36px rgba(15,23,42,0.14), inset 0 1px 0 rgba(255,255,255,0.95)',

color: '#0f172a',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent'
};

  headerStyle = {
    ...headerStyle,
    marginBottom: 5,
    paddingBottom: 5
  };

  tituloStyle = {
    ...tituloStyle,
    fontSize: 20,
    lineHeight: 1
  };

  subtituloStyle = {
    ...subtituloStyle,
    fontSize: 11,
    marginTop: 2
  };

  estadoMiniStyle = {
    ...estadoMiniStyle,
    fontSize: 11,
    padding: '5px 9px'
  };

quickRangeHeaderStyle = {
  ...quickRangeHeaderStyle,

  marginTop: 4,
  marginBottom: 3,

  color: '#7dd3fc',

  fontSize: 11,
  fontWeight: 900
};

  quickRangeGroupStyle = {
    ...quickRangeGroupStyle,
    gap: 5,
    marginBottom: 5
  };

  quickRangeButtonStyle = {
    ...quickRangeButtonStyle,
    padding: '6px 4px',
    fontSize: 12,
    borderRadius: 10
  };

  labelStyle = {
    ...labelStyle,
    fontSize: 19,
    lineHeight: 1,
    marginTop: 4,
    marginBottom: 3
  };

  inputStyle = {
    ...inputStyle,
    height: 38,
    padding: '4px 10px',
    marginTop: 1,
    marginBottom: 5,
    fontSize: 13,
    borderRadius: 11
  };

  controlGroupStyle = {
    ...controlGroupStyle,
    gap: 6,
    marginTop: 5
  };

  controlButtonStyle = {
    ...controlButtonStyle,
    height: 34,
    fontSize: 12,
    borderRadius: 11
  };

  playbackSpeedHeaderStyle = {
    ...playbackSpeedHeaderStyle,
    marginTop: 6,
    marginBottom: 3,
    fontSize: 11
  };

  speedGroupStyle = {
    ...speedGroupStyle,
    gap: 6,
    marginBottom: 5
  };

  speedButtonStyle = {
    ...speedButtonStyle,
    padding: '6px 4px',
    fontSize: 12,
    borderRadius: 10
  };

  playbackInfoStyle = {
  ...playbackInfoStyle,

  marginTop: 5,
  padding: '8px 10px',

  borderRadius: 12,

  background:
    'rgba(255,255,255,0.78)',

  border:
    '1px solid rgba(148,163,184,0.14)',

  color: '#334155',

  boxShadow:
    '0 5px 14px rgba(15,23,42,0.05)',

  fontSize: 11
};

  rangeStyle = {
    ...rangeStyle,
    marginTop: 5
  };

  progresoStyle = {
    ...progresoStyle,
    marginTop: 3,
    marginBottom: 2,
    fontSize: 11
  };

  verResumenButtonStyle = {
    ...verResumenButtonStyle,
    marginTop: 4,
    padding: '7px 10px',
    fontSize: 11,
    borderRadius: 11
  };

  
}
const mobileHistoryHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,

  marginBottom: 10,
  paddingBottom: 9,

  borderBottom:
    '1px solid rgba(148,163,184,0.16)'
};

const mobileHistoryEyebrowStyle = {
  marginBottom: 2,

  color: '#2563eb',

  fontSize: 8,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: 1.4
};

const mobileHistoryTitleStyle = {
  margin: 0,

  color: '#063b78',

  fontSize: 25,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: -0.7
};

const mobileHistoryVehicleStyle = {
  maxWidth: 'calc(100vw - 105px)',

  marginTop: 4,

  color: '#475569',

  fontSize: 10,
  lineHeight: 1.1,
  fontWeight: 850,

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const mobileHistoryCloseStyle = {
  width: 38,
  height: 38,
  minWidth: 38,

  padding: 0,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  borderRadius: '50%',

  border:
    '1px solid rgba(148,163,184,0.18)',

  background:
    'rgba(255,255,255,0.88)',

  color: '#0f172a',

  boxShadow:
    '0 5px 14px rgba(15,23,42,0.07)',

  fontSize: 23,
  lineHeight: 1,
  fontWeight: 500,

  cursor: 'pointer',

  WebkitTapHighlightColor:
    'transparent'
};

const playbackMainRowStyle = {
  display: 'flex',
  alignItems: 'stretch',

  gap: 8,
  marginTop: 7
};

const playPauseMobileButtonStyle = {
  width: 52,
  minWidth: 52,
  height: 42,

  padding: 0,

  borderRadius: 14,

  border:
    '1px solid rgba(14,165,233,0.35)',

  background:
    'linear-gradient(135deg, #0ea5e9, #2563eb)',

  color: '#ffffff',

  boxShadow:
    '0 7px 18px rgba(37,99,235,0.22)',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontSize: 19,
  lineHeight: 1,
  fontWeight: 950,

  touchAction: 'manipulation',
  WebkitTapHighlightColor:
    'transparent'
};

const mobileSummaryButtonStyle = {
  width: '100%',
  height: 40,

  marginTop: 7,
  padding: '0 12px',

  borderRadius: 14,

  border:
    '1px solid rgba(37,99,235,0.18)',

  background:
    'rgba(255,255,255,0.88)',

  color: '#0f3f78',

  boxShadow:
    '0 5px 15px rgba(15,23,42,0.07)',

  display: 'grid',

  gridTemplateColumns:
    '24px minmax(0, 1fr) 20px',

  alignItems: 'center',
  gap: 7,

  fontSize: 11,
  fontWeight: 950,

  touchAction: 'manipulation',
  WebkitTapHighlightColor:
    'transparent'
};

const mobileSummaryIconStyle = {
  width: 24,
  height: 24,

  borderRadius: 8,

  background:
    'rgba(14,165,233,0.12)',

  color: '#0284c7',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontSize: 17,
  fontWeight: 950
};

const mobileSummaryArrowStyle = {
  color: '#2563eb',

  fontSize: 15,
  fontWeight: 950,

  textAlign: 'right'
};
const mobileSummarySheetStyle = {
  position: 'fixed',

  left: 10,
  right: 10,

  bottom:
    'calc(env(safe-area-inset-bottom, 0px) + 40px)',

  zIndex: 30000,

  height: '48dvh',
  maxHeight: 440,

  padding: 0,

  overflow: 'hidden',

  borderRadius: 24,

  background:
    'linear-gradient(155deg, rgba(248,251,255,0.99), rgba(231,241,253,0.98))',

  border:
    '1px solid rgba(255,255,255,0.96)',

  boxShadow:
    '0 18px 48px rgba(15,23,42,0.18), inset 0 1px 0 rgba(255,255,255,0.98)',

  backdropFilter: 'blur(22px)',
  WebkitBackdropFilter: 'blur(22px)',

  color: '#0f172a',

  display: 'flex',
  flexDirection: 'column'
};

const mobileSummaryHeaderStyle = {
  flexShrink: 0,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  gap: 12,

  padding: '14px 14px 12px',

  borderBottom:
    '1px solid rgba(148,163,184,0.16)'
};

const mobileSummaryEyebrowStyle = {
  marginBottom: 3,

  color: '#2563eb',

  fontSize: 8,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: 1.3
};

const mobileSummaryTitleStyle = {
  display: 'block',

  color: '#063b78',

  fontSize: 21,
  lineHeight: 1.1,
  fontWeight: 950,

  letterSpacing: -0.5
};

const mobileSummaryVehicleStyle = {
  display: 'block',

  maxWidth: 'calc(100vw - 110px)',

  marginTop: 4,

  color: '#64748b',

  fontSize: 10,
  fontWeight: 850,

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const mobileSummaryCloseStyle = {
  width: 36,
  height: 36,
  minWidth: 36,

  padding: 0,

  borderRadius: '50%',

  border:
    '1px solid rgba(148,163,184,0.18)',

  background:
    'rgba(255,255,255,0.90)',

  color: '#0f172a',

  boxShadow:
    '0 5px 14px rgba(15,23,42,0.07)',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontSize: 22,
  lineHeight: 1,
  fontWeight: 500,

  cursor: 'pointer'
};

const mobileSummaryScrollStyle = {
  minHeight: 0,
  flex: 1,

  padding: '12px 12px 18px',

  overflowX: 'hidden',
  overflowY: 'auto',

  WebkitOverflowScrolling: 'touch'
};

const mobileSummaryGridStyle = {
  display: 'grid',

  gridTemplateColumns: '1fr',

  gap: 10
};

const mobileSummarySectionStyle = {
  minWidth: 0,

  display: 'grid',
  alignContent: 'start',

  gap: 7,

  padding: 12,

  borderRadius: 18,

  background:
    'rgba(255,255,255,0.82)',

  border:
    '1px solid rgba(255,255,255,0.96)',

  boxShadow:
    '0 6px 17px rgba(15,23,42,0.055)'
};

const mobileSummarySectionTitleStyle = {
  marginBottom: 2,

  color: '#2563eb',

  fontSize: 9,
  fontWeight: 950,

  textTransform: 'uppercase',
  letterSpacing: 0.9
};

const mobileSummaryRouteItemStyle = {
  display: 'grid',

  gap: 4,

  padding: 10,

  borderRadius: 13,

  background:
    'rgba(241,245,249,0.82)',

  border:
    '1px solid rgba(148,163,184,0.12)',

  color: '#334155',

  fontSize: 10,
  lineHeight: 1.35
};

const mobileSummaryRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  gap: 12,

  padding: '7px 0',

  borderBottom:
    '1px solid rgba(148,163,184,0.13)',

  color: '#475569',

  fontSize: 11
};

const mobileSummaryEmptyStyle = {
  padding: 11,

  borderRadius: 13,

  background:
    'rgba(241,245,249,0.82)',

  border:
    '1px solid rgba(148,163,184,0.12)',

  color: '#64748b',

  fontSize: 10,
  fontWeight: 750
};
export default HistoricalPlaybackV2;